import React, { Fragment } from "react";
import Header from "./Header";
import FadeInOnScroll from "./UI/FadeInOnScroll";
import styles from "./StatusPage.module.css";
import cage from "../Assets/cage.jpeg";
import computer from "../Assets/computer.jpeg";
import demo from "../Assets/demo_trim.mp4";
import foot from "../Assets/foot.jpeg";
import side from "../Assets/SideShot.gif";

import top from "../Assets/top.jpeg";
import topshot from "../Assets/topshot.gif";

function StatusPage() {
  return (
    <Fragment>
      <Header intro="Current Status of the Hyzerberg 1.0"></Header>

      <div className={styles.content}>
        <FadeInOnScroll>
          <div className={styles.text}>
            <p>
              Our prototype is able to instantaneously calculate the velocity
              and nose angle of a disc as it is thrown through a Python script
              that uses OpenCV and Python. Some of the tools we used in the
              script were cuda and gstreamer. We also 3D printed custom housings
              for the J1020 computer that we used as well as the Arducam cameras
              we used.
            </p>
            <p>
              While we were able to calculate the other 4 parameters necessary
              for simulating disc flight, due to time constraints and the
              physical computing ability of the J1020 we were not able to
              instantaneously calculate all the parameters while maintaining a
              fast frame rate.
            </p>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <video src={demo} width="50%" controls autoplay></video>
            <p>
              This is a demo of our final prototype. A user throws a disc into
              our net and our script instantaneously returns the velocity and
              nose angle of the disc.
            </p>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <p>
              This is a photo of our entire setup. We have a large pvc cage with
              netting around it to protect the room and the users. On the left
              is our computer and monitor setup where the feedback is shown to
              the user.
            </p>
            <img src={cage} alt="demo"></img>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <img src={computer} alt="demo"></img>
            <p>
              This is the Seeed Computer J1020. It uses a NVIDIA Jetson Nano
              module and allows us to process our video streams and compute our
              flight parameters. The module is relatively powerful - more
              powerful than a RaspberryPi or an Arduino - but we would have
              preferred to purchase an Orin or Xavier module. We were unable to
              do so because of budget limitations.
            </p>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <p>
              We 3D-printed custom footings for the PVC poles and attached them
              to planks of wood to bolster the cage. Our initial version of the
              cage was warped and oscillated relentlessly after a disc was
              thrown into the net. These feet worked in conjunction with a few
              other changes to make the cage incredibly sturdy. On the left of
              the photo is an I-hook where we attached strings and tied them to
              the corner diagonal from the hook. This also helped eliminate the
              osciallations of the cage.
            </p>
            <img src={foot} alt="demo"></img>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <img src={top} alt="demo"></img>
            <p>
              This is a photo of our top-down camera. It is an Arducam IMX477
              camera with an HDMI adapter and casing that allows the camera to
              be connected very far from the J1020. We lasercut a custom acrylic
              housing with holes for zip ties to securely attach the camera.
            </p>
          </div>
        </FadeInOnScroll>
        <FadeInOnScroll>
          <div className={styles.block}>
            <p>
              This gif shows the flight parameters we are able to calculate from
              the side camera. Using color thresholding and detection we can
              calculate the nose angle and the vertical launch angle.
            </p>
            <img src={side} alt="demo"></img>
          </div>
        </FadeInOnScroll>

        <FadeInOnScroll>
          <div className={styles.block}>
            <img src={topshot} alt="demo"></img>
            <p>
              This gif shows the flight parameters we are able to calculate from
              the top-down camera. Using color thresholding on the custom vinyl
              stickers as well as calculating the moments of those colorblocks,
              we can calculate the velocity, spin rate, horizontal launch angle,
              and bank.
            </p>
          </div>
        </FadeInOnScroll>
      </div>
    </Fragment>
  );
}

export default StatusPage;
